import { SG } from "@bokio/designsystem/components/SpacingGroup/SpacingGroup";
import { Paragraph } from "@bokio/designsystem/components/TypographicElements/TypographicElements";
import { GeneralLangFactory } from "@bokio/lang";

import type { ReactNode } from "react";

interface DetailedMessageProps {
	content: ReactNode;
	referenceId?: ReactNode | undefined;
}

const DetailedMessage = (message: DetailedMessageProps) => {
	return (
		<SG section gap="8">
			<div>{message.content}</div>
			{message.referenceId && (
				<div>
					<Paragraph color="ui-3" style="caption-default">
						{GeneralLangFactory().Error_Notification_Reference}
						{message.referenceId}
					</Paragraph>
				</div>
			)}
		</SG>
	);
};

export default DetailedMessage;
